<div class="modal-all">    
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ "modals.add_assignament.title" | translate }}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCanvas()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
   <div class="modal-body">
        <div id="modal_add_block"></div>
        <form [formGroup]="assignamentForm" (ngSubmit)="saveAssignament()" class="d-flex flex-column gap-4">
            <div class="row">
            	<div class="form-group">
            		<b>
                        {{ "modals.add_assignament.date_and_time" | translate }}
                    </b>
                    <div class="row dates_list">
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconCalendar" class="ison_fs_16"></tui-icon>
                    	</div>
                    	<div class="col-10">
                    		09/08/24 de 09:00 -14:00
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconTrash" class="ison_fs_16"></tui-icon>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconCalendar" class="ison_fs_16"></tui-icon>
                    	</div>
                    	<div class="col-10">
                    		09/08/24 de 09:00 -18:00
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconTrash" class="ison_fs_16"></tui-icon>
                    	</div>
                    </div>
                    <div class="row">
                    	<div class="col">
                    		<button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_add_date" size="m" appearance="secondary" icon="tuiIconPlusCircle">
			            {{ "modals.add_assignament.add_more_dates" | translate }}
					        </button>
                    	</div>
                    </div>	
                    <br>
            	</div>
            	<div class="form-group mb_custom">
                	<div class="col-12">
	                    <label class="label_form">{{ "modals.add_assignament.new_date" | translate }}*</label>
	                    <tui-input-date
	                        formControlName="date"
	                        tuiTextfieldSize="m" 
	                        [tuiTextfieldLabelOutside]="true"
	                        (focusedChange)="searchDiv2()"
	                        [tuiTextfieldCleaner]="true"
	                    >
	                        {{ "modals.add_assignament.select_date" | translate }}
	                    </tui-input-date>
                	</div>
                </div>
                <div class="form-group form-group-select">
                	<div class="col check_div">
                        <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="allDay" size="m"></tui-checkbox> {{ "modals.add_assignament.all_day" | translate }}
                    </div>
                	<div class="row">
                        <div class="col">
                            <br>
                            <label class="label_form">{{ "modals.add_assignament.block_start_time" | translate }}</label>
                            <tui-input-time
                                formControlName="startTime"
                                class="input_form"
                                [items]="hours"
                                [tuiTextfieldLabelOutside]="true"
                                (focusedChange)="searchDiv2()"
                            >
                            </tui-input-time>
                        </div>
                        <div class="col">
                            <br>
                            <label class="label_form">{{ "modals.add_assignament.block_end_time" | translate }}</label>
                            <tui-input-time
                                formControlName="endTime"
                                class="input_form"
                                [items]="hours"
                                [tuiTextfieldLabelOutside]="true"
                                (focusedChange)="searchDiv2()"
                            >
                            </tui-input-time>
                        </div>
                    </div>
                    <div class="row">
                    	<div class="col-12 t_r">
                    		<button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_cancel_date" size="m" appearance="secondary">{{ "USER_NAVBAR.6" | translate }}</button>
					        <button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_save_date" size="m" appearance="secondary">
			            {{ "modals.add_assignament.save_date" | translate }}
					        </button>
                    	</div>
                    </div>
                </div>
                <div class="form-group">
            		<b>
                        {{ "modals.add_assignament.operative_zones" | translate }}
                    </b>
                    <div class="row dates_list">
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconMapPin" class="ison_fs_16"></tui-icon>
                    	</div>
                    	<div class="col-10">
                    		Barcelona
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconTrash" class="ison_fs_16"></tui-icon>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconMapPin" class="ison_fs_16"></tui-icon>
                    	</div>
                    	<div class="col-10">
                    		Madrid
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconTrash" class="ison_fs_16"></tui-icon>
                    	</div>
                    </div>
                    <div class="row">
                    	<div class="col">
                    		<button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_add_date" size="m" appearance="secondary" icon="tuiIconPlusCircle">
			            {{ "modals.add_assignament.add_more_zones" | translate }}
					        </button>
                    	</div>
                    </div>	
                    <br>
            	</div>
                <div class="form-group form-group-select">
                    <div class="col-12">
                        <label class="label_form">{{ "modals.add_assignament.operative_zone" | translate }}*</label>
                        <tui-select
                            tuiTextfieldSize="s"
                            formControlName="operativeZone"
                            class="input_form"
                            (click)="searchDiv('zone')"
                            [tuiTextfieldLabelOutside]="true"
                        >
                            {{ "modals.add_assignament.select_operative_zone" | translate }}
                            <tui-data-list-wrapper
                                *tuiDataList
                                [items]="operatives"
                            ></tui-data-list-wrapper>
                        </tui-select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-12">
                        <label class="label_form">{{ "modals.add_assignament.delivery_address" | translate }}*</label>
                        <tui-input formControlName="startAdress" class="input_form" [tuiTextfieldLabelOutside]="true" tuiTextfieldIcon="tuiIconMapPin">
                            {{ "modals.add_assignament.enter_delivery_address" | translate }}*
                        </tui-input>
                    </div>
                    <div class="row">
                    	<div class="col-12 t_r">
                    		<button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_cancel_date" size="m" appearance="secondary">{{ "USER_NAVBAR.6" | translate }}</button>
					        <button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_save_date" size="m" appearance="secondary">
			            {{ "modals.add_assignament.save_zone" | translate }}
					        </button>
                    	</div>
                    </div>
                </div>

                <div class="form-group">
                	<br>
            		<b>
                        {{ "modals.add_assignament.products" | translate }} (0 {{ "modals.add_assignament.products_count" | translate }})
                    </b>
                    <div class="row dates_list">
                    	<div class="col-11">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="revisiones" size="m"></tui-checkbox> {{ "modals.add_assignament.revisions" | translate }}
	                        </div>
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconChevronDown" class="ison_fs_16" *ngIf="!openRevisiones" (click)="toggleDiv('revisiones')"></tui-icon>
                    		<tui-icon icon="tuiIconChevronUp" class="ison_fs_16" *ngIf="openRevisiones" (click)="toggleDiv('revisiones')"></tui-icon>
                    	</div>
                    	<div class="col-12" *ngIf="openRevisiones">
                    		<div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "products.ITV" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.pre-mot" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.mot-homologation" | translate }}</div>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-11">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="lavado" size="m"></tui-checkbox>{{ "common.services.Motorbike wash" | translate }}</div>
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconChevronDown" class="ison_fs_16" *ngIf="!openLavado" (click)="toggleDiv('lavado')"></tui-icon>
                    		<tui-icon icon="tuiIconChevronUp" class="ison_fs_16" *ngIf="openLavado" (click)="toggleDiv('lavado')"></tui-icon>
                    	</div>
                    	<div class="col-12" *ngIf="openLavado">
                    		<div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox> {{ "modals.add_assignament.specialized_centers" | translate }}
	                        </div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox> {{ "modals.add_assignament.upholstery" | translate }}
	                        </div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox> {{ "modals.add_assignament.integral" | translate }}
	                        </div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.headlight-polishing" | translate }}</div>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-11">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="mantenimiento" size="m"></tui-checkbox> {{ "modals.add_assignament.maintenance" | translate }}
	                        </div>
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconChevronDown" class="ison_fs_16" *ngIf="!openMant" (click)="toggleDiv('mant')"></tui-icon>
                    		<tui-icon icon="tuiIconChevronUp" class="ison_fs_16" *ngIf="openMant" (click)="toggleDiv('mant')"></tui-icon>
                    	</div>
                    	<div class="col-12" *ngIf="openMant">
                    		<div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox> {{ "modals.add_assignament.packs" | translate }}
	                        </div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.refueling-topping" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.pre-mot" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox> Pre-ITV + ITV
	                        </div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.services.Workshop at home" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.tyres" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.services.Cafler Ready" | translate }}</div>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-11">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="aparcar" size="m"></tui-checkbox> {{ "modals.add_assignament.we_park_your_vehicle" | translate }}
	                        </div>
                    	</div>
                    	<div class="col-1">
                    		<tui-icon icon="tuiIconChevronDown" class="ison_fs_16" *ngIf="!openApar" (click)="toggleDiv('apar')"></tui-icon>
                    		<tui-icon icon="tuiIconChevronUp" class="ison_fs_16" *ngIf="openApar" (click)="toggleDiv('apar')"></tui-icon>
                    	</div>
                    	<div class="col-12" *ngIf="openApar">
                    		<div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" size="m"></tui-checkbox>{{ "common.products.parking" | translate }}</div>
	                        <div class="col check_div subcheck">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10"  size="m"></tui-checkbox>{{ "common.services.Valet Train Station" | translate }}</div>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-12">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="tramites" size="m"></tui-checkbox> {{ "modals.add_assignament.name_change_procedures" | translate }}
	                        </div>
                    	</div>
                    </div>
                    <div class="row dates_list">
                    	<div class="col-12">
                    		<div class="col check_div">
	                            <tui-checkbox class="tui-space_bottom-3 mr_10" formControlName="grua" size="m"></tui-checkbox> {{ "modals.add_assignament.tow_truck_assistance" | translate }}
	                        </div>
                    	</div>
                    </div>
                    <br>
            	</div>
                <br>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 btn_desc but_footer" size="m" appearance="secondary" (click)="closeCanvas()">{{ "comercial.clients.modal-add-client.button_discard" | translate }}</button>
        <button tuiButton type="button" class="tui-space_right-3 tui-space_bottom-3 but_footer"
            size="m" appearance="primary-button" icon="tuiIconPlusCircleLarge" [class.disabled]="!assignamentForm.valid" [attr.disabled]="!assignamentForm.valid ? true : null" *ngIf="!assignamentForm.valid">{{ "modals.add_assignament.add_button_text" | translate }}</button>
        <button tuiButton type="button" (click)="saveAssignament()" class="tui-space_right-3 tui-space_bottom-3 but_footer"
        size="m" appearance="primary-button" icon="tuiIconPlusCircleLarge" *ngIf="assignamentForm.valid">{{ "modals.add_assignament.add_button_text" | translate }}</button>
    </div>
</div>